export const environment = {
  production: true,
  // apiBaseUrl : 'https://dev-storyteller.mobileprogramming.net/',
  apiBaseUrl : 'https://api.gpsstoryteller.com/',
  baseUrl : 'https://www.gpsstoryteller.com/'
};
